import React from 'react';
import { TakeSurveyQuestion } from '../../types';
import AnswerInput from './AnswerInput';
import { cn } from '../../../../utils/cn';

interface QuestionDisplayProps {
  question: TakeSurveyQuestion;
  questionNumber: number;
  totalQuestions: number;
  value: string | string[] | number | null;
  onChange: (value: string | string[] | number | null) => void;
  disabled?: boolean;
}

const QuestionDisplay: React.FC<QuestionDisplayProps> = ({
  question,
  questionNumber,
  totalQuestions,
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="bg-[var(--color-bg-base)] rounded-xl border border-[var(--color-border-primary)] p-6 sm:p-8 min-h-[320px]">
      {/* Question Number Badge */}
      <div className="mb-6">
        <span
          className={cn(
            'inline-flex items-center px-4 py-2 rounded-full',
            'text-sm font-semibold bg-[var(--color-primary-600)] text-white'
          )}
        >
          Question {questionNumber} of {totalQuestions}
        </span>
      </div>

      {/* Question Text */}
      <h2 className="text-heading-md text-[var(--color-text-primary)] mb-8 leading-relaxed">
        {question.text}
        {question.isRequired && (
          <span className="text-[var(--color-error-dark)] ml-1">*</span>
        )}
      </h2>

      {/* Answer Input */}
      <AnswerInput
        question={question}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

export default QuestionDisplay;
